<template>
    <v-list-item class="px-0">
        <v-list-item-avatar class="mr-1 mr-md-3">
            <v-icon
                color="teal accent-4"
                v-text="'mdi-check-circle-outline'"
            />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-subtitle v-text="account_number"></v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action v-if="removable" class="ml-1 ml-md-3 pt-3">
            <v-btn @click="removeAccount" icon>
                <v-icon color="red lighten-1">
                    mdi-minus-circle
                </v-icon>
            </v-btn>
        </v-list-item-action>
    </v-list-item>
</template>

<script>

    export default {
        props: {
            input: {
                type: Object,
                default: () => ({}),
            },
            editable: {
                type: Boolean,
                default: true,
            },
            removable: {
                type: Boolean,
                default: true,
            },
        },
      data() {
          return {
              holder_name: null,
              account_number: null,
              bank_code: null,
          };
      },
      watch: {
        input: function(data) {
            this.setData(data);
        },
      },
      mounted() {
          this.setData(this.input);
      },
      methods: {
          setData(data) {
              this.holder_name = data.holder_name;
              this.account_number = data.account_number;
              this.bank_code = data.bank_code;
          },
          removeAccount() {
              this.$emit('remove');
          },
      },
  };
</script>
